interface RankingItem {
  rank: number;
  title: string;
  category: string;
  hotValue: string;
  trend: 'up' | 'down' | 'new';
}

const rankings: RankingItem[] = [
  { rank: 1, title: '《奔跑吧》最新季', category: '户外真人秀', hotValue: '986.5万', trend: 'up' },
  { rank: 2, title: '《脱口秀大会》第六季', category: '搞笑脱口秀', hotValue: '872.3万', trend: 'new' },
  { rank: 3, title: '《向往的生活》', category: '慢生活综艺', hotValue: '765.8万', trend: 'down' },
  { rank: 4, title: '《欢乐喜剧人》', category: '喜剧综艺', hotValue: '698.2万', trend: 'up' },
  { rank: 5, title: '《密室大逃脱》', category: '悬疑推理', hotValue: '542.1万', trend: 'new' },
];

const trendIcon: Record<string, string> = {
  up: 'ri-arrow-up-line text-primary-500',
  down: 'ri-arrow-down-line text-foreground-400',
  new: 'ri-flashlight-line text-accent-500',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block bg-primary-100 text-primary-700 text-xs font-semibold px-3 py-1 rounded-full uppercase tracking-wide mb-3">
            热度榜单
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-foreground-950 mb-3">
            综艺热度排行榜
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[600px] mx-auto">
            基于全网观看热度的综艺节目实时排行，看看大家都在追什么
          </p>
        </div>

        <div className="bg-background-100 rounded-2xl border border-background-200/70 overflow-hidden">
          {/* Header */}
          <div className="flex items-center px-5 py-3 bg-background-200/50 border-b border-background-200/70 text-xs font-semibold text-foreground-500">
            <span className="w-12 text-center">排名</span>
            <span className="flex-1">节目名称</span>
            <span className="hidden sm:block w-24 text-center">分类</span>
            <span className="w-28 text-right">热度值</span>
            <span className="w-12 text-center">趋势</span>
          </div>
          {/* Rows */}
          {rankings.map((item) => (
            <div
              key={item.rank}
              className="flex items-center px-5 py-4 border-b border-background-200/50 last:border-b-0 hover:bg-background-50 transition-colors cursor-pointer"
            >
              <span className={`w-12 text-center text-lg font-extrabold ${
                item.rank <= 3 ? 'text-primary-500' : 'text-foreground-400'
              }`}>
                {item.rank <= 3 ? (
                  <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-primary-100 text-primary-600 text-sm font-bold">
                    {item.rank}
                  </span>
                ) : (
                  item.rank
                )}
              </span>
              <span className="flex-1 text-sm font-semibold text-foreground-900 truncate pr-2">
                {item.title}
              </span>
              <span className="hidden sm:block w-24 text-center text-xs text-foreground-500 whitespace-nowrap">
                {item.category}
              </span>
              <span className="w-28 text-right text-sm font-mono font-semibold text-foreground-700 whitespace-nowrap">
                {item.hotValue}
              </span>
              <span className="w-12 flex justify-center">
                <i className={`text-base ${trendIcon[item.trend]}`}></i>
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}